import { useQuery } from "@tanstack/react-query";

import { ArtifactQueryParams } from "../../types/artifact";
import { logError } from "../../utils/error";
import { fetchArtifacts } from "../queries/artifacts";

export const useArtifacts = (params: ArtifactQueryParams, options?: { enabled?: boolean }) => {
  const { page, pageSize, sortField, sortDirection, filters, interactionIds, permittedEmails } = params;

  return useQuery({
    enabled: options?.enabled ?? true,
    queryKey: ["artifacts", page, pageSize, sortField, sortDirection, filters, interactionIds, permittedEmails],
    queryFn: () => fetchArtifacts(params),
    staleTime: 0, //2 * 60 * 1000, // 2 minutes - artifacts change more frequently than protocols/users
    gcTime: 0, //5 * 60 * 1000, // 5 minutes
    retry: (failureCount, error) => {
      logError(`[useArtifacts] retry on error (attempt ${failureCount})`, error);
      return failureCount < 3;
    },
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    // Keep previous data while fetching new data (for pagination)
    placeholderData: (previousData) => previousData
  });
};
